import { PostalZoneMapper } from './PostalZoneMapper.js';

class PostalZonesRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  allOrigins(params) {
    return this.apiClient.get('v1/locations/postalzones/origins', {
      ...params
    }).then(response => response.data.map(PostalZoneMapper.createModelFromResponse));
  }
  allDestinations(params) {
    return this.apiClient.get('v1/locations/postalzones/destinations', {
      ...params
    }).then(response => response.data.map(PostalZoneMapper.createModelFromResponse));
  }
}

export { PostalZonesRepository };
//# sourceMappingURL=PostalZonesRepository.js.map
